import { useStaticQuery, graphql } from "gatsby";

const AllBlogsQuery = () => {
  const allBlogsQuery = useStaticQuery(graphql`
    query AllBlogsQuery {
      allSanityBlog(sort: { fields: publishDate, order: DESC }) {
        nodes {
          ...blogPreview
        }
      }
      allSanityBlogCategory(sort: { fields: orderRank, order: ASC }) {
        nodes {
          main {
            title
            slug {
              current
            }
            hero {
              ...sanityHero
            }
          }
          _id
          _key
          _type
        }
      }
    }
  `);
  return allBlogsQuery;
};
export default AllBlogsQuery;
